<template>
  <div class="container-fluid">
    <titular />
    <ul class="list-inline">
      <li class="list-inline-item">
        <modal ref="modalCreacion" titulo="Afegir conjunt de dades" icono="fa-solid fa-plus" :loading="loading.creacion" @abrir="abrirModal('autofocusCreacion')" @cerrar="cerrarCreacion">
          <template v-slot:body>
            <form id="form-creacion" autocomplete="off" @submit.prevent="crear">
              <div class="form-group">
                <label for="nuevo-url">URL conjunt de dades</label>
                &nbsp;
                <i v-if="validDatasetId == true" class="fa-solid fa-circle-check text-success"></i>
                <i v-if="validDatasetId == false" class="fa-solid fa-circle-xmark text-danger"></i>
                <input ref="autofocusCreacion" type="url" class="form-control" id="nuevo-url" v-model="nuevos.conjuntDades.url" :disabled="loading.creacion" maxlength="255" aria-describedby="help-dataset-id" required>
                <small id="help-dataset-id" class="form-text text-muted">
                  Aquesta URL has de copiar-la des d'un conjunt de dades del catàleg de dades obertes.
                </small>
              </div>
              <div class="form-group" hidden>
                <label for="nuevo-dataset_id">Id. conjunt de dades</label>
                <input type="text" class="form-control-plaintext" id="nuevo-dataset_id" v-model="nuevos.conjuntDades.dataset_id" :disabled="loading.creacion" maxlength="9" readonly required>
              </div>
              <div class="form-group">
                <label for="nuevo-tag">Tag</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="nuevo-tag" v-model="nuevos.conjuntDades.tag" :disabled="loading.creacion" maxlength="255" list="datalist-tag" required />
                </div>
              </div>
              <div class="form-group">
                <label>Columnes d'interés <span class="spinner-grow spinner-grow-sm" role="status" :hidden="!loading.dataset"><span class="sr-only">Loading...</span></span></label>
                <div v-if="fields.length">
                  <div v-for="field in fields" :key="field.fieldName" class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" :value="field.fieldName" :id="`field-${field.fieldName}`" name="camps" v-model="nuevos.conjuntDades.camps" />
                    <label class="custom-control-label" :for="`field-${field.fieldName}`">
                      <b>{{ field.name }}</b>
                      <br>
                      {{ field.description }}
                      <br>
                      <span v-if="field.examples">Exemples: <i>{{ field.examples }}</i></span>
                    </label>
                  </div>
                </div>
                <div v-else><i class="text-muted">Carrega una URL de conjunt de dades per veure les columnes adients.</i></div>
              </div>
              <div class="form-group">
                <label for="nuevo-filtre">Columna filtre <span class="spinner-grow spinner-grow-sm" role="status" :hidden="!loading.dataset"><span class="sr-only">Loading...</span></span></label>
                <select class="form-control custom-select" id="nuevo-filtre" v-model="nuevos.conjuntDades.filtre" :disabled="loading.creacion" aria-describedby="help-filtre" required>
                  <option v-for="uno in fields" :key="uno.fieldName" :value="uno.fieldName">{{ uno.name }}</option>
                </select>
                <small id="help-filtre" class="form-text text-muted">
                  Selecciona la columna del conjunt de dades que s'utilitzarà com a criteri de filtre per a les consultes.
                </small>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-creacion" :disabled="loading.creacion"><i-submit icono="fa-plus" :loading="loading.creacion" />Confirmar</button>
          </template>
        </modal>
      </li>
      <li class="list-inline-item">
        <modal ref="modalRecopilador" titulo="Recopilador de dades" icono="fa-solid fa-file-arrow-down" :loading="loading.recopilador" @abrir="abrirModal('autofocusRecopilador')" @cerrar="cerrarRecopilador">
          <template v-slot:body>
            <form id="form-recopilador" autocomplete="off" @submit.prevent="recopilar">
              <div class="form-group">
                <label for="recopilador-tag">Tag</label>
                <select ref="autofocusRecopilador" class="form-control custom-select" id="recopilador-tag" name="tag" v-model="recopilador.tag" :disabled="loading.recopilador" required>
                  <option v-for="tag in tags" :key="tag.id" :value="tag.id">{{ tag.titol }}</option>
                </select>
              </div>
              <div class="form-group">
                <div class="d-flex justify-content-between align-items-center mb-1">
                  <label for="recopilador-filtre" class="mb-0">
                    Valor de filtre
                    <i class="fa-solid fa-circle-info ml-1 text-muted" title="Si actives la cerca exacta, només es trobaran valors exactes. Si no, es trobaran valors que continguin el text introduït." v-tooltip></i>
                  </label>
                  <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="switch-cerca-exacta" v-model="recopilador.cercaExacta" :disabled="loading.recopilador" />
                    <label class="custom-control-label small text-muted" for="switch-cerca-exacta">Cerca exacta</label>
                  </div>
                </div>
                <input type="text" class="form-control" id="recopilador-filtre" name="filtre" v-model="recopilador.filtre" :disabled="loading.recopilador" maxlength="255" required>
              </div>
              <div class="form-group">
                <label>Conjunts de dades</label>
                <div v-if="selectedDatasets.length">
                  <div v-if="selectedDatasets.length > 1" class="list-group-item px-0 py-2 border-top-0 border-left-0 border-right-0 d-flex justify-content-between align-items-center">
                    <div class="custom-control custom-checkbox">
                      <input type="checkbox" class="custom-control-input" id="check-all-datasets" v-model="allDatasetsSelected" ref="checkAllDatasets" />
                      <label class="custom-control-label text-muted small" for="check-all-datasets">
                        Seleccionar tots
                      </label>
                    </div>
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="switch-expandir-tot" v-model="allExpanded" @change="toggleAll" />
                      <label class="custom-control-label small text-muted" for="switch-expandir-tot">Desplegar tot</label>
                    </div>
                  </div>
                  <div v-for="dataset in selectedDatasets" :key="`rec-ds-${recopilador.tag}-${dataset.id}`" class="list-group-item px-0 py-2 border-left-0 border-right-0">
                    <div class="d-flex justify-content-between align-items-center">
                      <div v-if="selectedDatasets.length > 1" class="custom-control custom-checkbox mr-3">
                        <input class="custom-control-input" type="checkbox" :value="dataset.id" :id="`rec-dataset-${dataset.id}`" name="conjuntsDades" v-model="recopilador.conjuntsDades" />
                        <label class="custom-control-label" :for="`rec-dataset-${dataset.id}`">
                          <span class="badge badge-dark text-monospace mr-1">{{ dataset.dataset_id }}</span>
                          {{ dataset.titol }}
                        </label>
                      </div>
                      <div v-else class="mr-3">
                        <span class="badge badge-dark text-monospace mr-1">{{ dataset.dataset_id }}</span>
                        {{ dataset.titol }}
                      </div>
                      <button class="btn btn-light btn-sm rounded-circle" type="button" data-toggle="collapse" :data-target="`#details-${dataset.id}`" aria-expanded="false" :aria-controls="`details-${dataset.id}`" title="Veure detalls" v-tooltip>
                        <i class="fa-solid fa-chevron-down"></i>
                      </button>
                    </div>
                    <div class="collapse pt-2 pl-4" :id="`details-${dataset.id}`">
                      <div class="card card-body p-2 small bg-light border-0">
                        <div class="mb-1"><strong>Columna filtre:</strong> <span class="text-muted">{{ dataset.tag.filtre }}</span></div>
                        <div><strong>Camps:</strong> <span class="text-muted">{{ dataset.tag.camps.join(", ") }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else><i class="text-muted">Selecciona un tag per veure els conjunts de dades adients.</i></div>
              </div>
            </form>
          </template>
          <template v-slot:footer>
            <button type="submit" class="btn btn-primary" form="form-recopilador" :disabled="loading.recopilador || !recopilador.conjuntsDades.length"><i-submit icono="fa-file-arrow-down" :loading="loading.recopilador" />Confirmar</button>
          </template>
        </modal>
      </li>
    </ul>
    <vue-bootstrap4-table ref="tabla" :rows="completeRows" :columns="columns" :classes="classes" :config="config" :actions="actionsExportar" @exportarTabla="exportarTablaPrevio" @exportarBolcat="exportarBolcatPrevio">
      <template slot="empty-results">No hi ha cap conjunt de dades</template>
      <template slot="global-search-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="refresh-button-text">
        <i class="fa-solid fa-rotate" title="Actualitzar dades" @click="getData" v-tooltip></i>
      </template>
      <template slot="reset-button-text">
        <i class="fa-solid fa-eraser" title="Reiniciar vista" v-tooltip></i>
      </template>
      <template slot="sort-asc-icon">
        <i class="fa-solid fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa-solid fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fas fa-sort"></i>
      </template>
      <template slot="simple-filter-clear-icon">
        <i class="fa-solid fa-circle-xmark"></i>
      </template>
      <template slot="paginataion-previous-button">
        <i class="fa-solid fa-angle-left"></i>
      </template>
      <template slot="paginataion-next-button">
        <i class="fa-solid fa-angle-right"></i>
      </template>
      <template v-slot:pagination-info="props">
        Registres: {{ props.currentPageRowsLength }} de {{ props.filteredRowsLength }}<template v-if="props.filteredRowsLength !== props.originalRowsLength"> ({{ props.originalRowsLength }} en total)</template>
      </template>
      <template slot="selected-rows-info" slot-scope="props">{{ props }} Selecció: {{ props.selectedItemsCount }}</template>
      <template slot="acciones" slot-scope="props">
        <div class="btn-group btn-group-sm" role="group" aria-label="Accions">
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-editar-${props.row.id}`" title="Editar conjunt de dades" v-tooltip><i class="fa-solid fa-pen-to-square"></i></button>
          <button class="btn btn-secondary" data-toggle="modal" :data-target="`#modal-eliminar-${props.row.id}`" title="Eliminar conjunt de dades" v-tooltip><i class="fa-solid fa-trash-can"></i></button>
        </div>
        <div class="text-left">
          <modal :ref="`modalEdicion${props.row.id}`" titulo="Editar conjunt de dades" icono="fa-solid fa-pen-to-square" btnClass="btn-secondary" :hayLanzador="false" :modalId="`editar-${props.row.id}`" :loading="loading.edicion" @abrir="abrirEdicion(props.row.id)" @cerrar="cerrarEdicion">
            <template v-slot:body>
              <form :id="`form-edicion${props.row.id}`" autocomplete="off" @submit.prevent="editar(props.row.id)">
                <div class="form-group">
                  <label :for="`dataset_id${props.row.id}`">Id. extern</label>
                  <input type="text" class="form-control" :id="`dataset_id${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).dataset_id" disabled>
                </div>
                <div class="form-group">
                  <label :for="`titol${props.row.id}`">Títol</label>
                  <input :ref="`autofocusEdicion${props.row.id}`" type="text" class="form-control" :id="`titol${props.row.id}`" v-model="getRowId(props.row.id, rowsBuffer).titol" :disabled="loading.edicion" required>
                </div>

                <div class="form-group">
                  <label :for="`active-tag-${props.row.id}`">Tag a editar</label>
                  <select class="form-control custom-select" :id="`active-tag-${props.row.id}`" v-model="activeTagId" :disabled="loading.edicion">
                    <option v-for="tag in getRowId(props.row.id, rowsBuffer).tags" :key="tag.id_tag" :value="tag.id_tag">{{ tag["tags.titol"] }}</option>
                  </select>
                  <small class="form-text text-muted">Les columnes d'interès i el filtre depenen del tag seleccionat. Els canvis realitzats en qualsevol tag es guardaran en confirmar, encara que en aquest moment no estigui seleccionat.</small>
                </div>

                <div v-if="getEditingTag(props.row.id)">
                  <div class="form-group">
                    <label>Columnes d'interés <span class="spinner-grow spinner-grow-sm" role="status" :hidden="!loading.dataset"><span class="sr-only">Loading...</span></span></label>
                    <div v-if="fields.length">
                      <div v-for="field in fields" :key="field.fieldName" class="custom-control custom-checkbox">
                        <input class="custom-control-input" type="checkbox" :value="field.fieldName" :id="`field-edit-${props.row.id}-${field.fieldName}`" v-model="getEditingTag(props.row.id).camps" />
                        <label class="custom-control-label" :for="`field-edit-${props.row.id}-${field.fieldName}`">
                          <b>{{ field.name }}</b>
                          <br>
                          {{ field.description }}
                        </label>
                      </div>
                    </div>
                    <div v-else><i class="text-muted">Carrega una URL de conjunt de dades vàlida per veure les columnes.</i></div>
                  </div>
                  <div class="form-group">
                    <label :for="`filtre-edit-${props.row.id}`">Columna filtre <span class="spinner-grow spinner-grow-sm" role="status" :hidden="!loading.dataset"><span class="sr-only">Loading...</span></span></label>
                    <select class="form-control custom-select" :id="`filtre-edit-${props.row.id}`" v-model="getEditingTag(props.row.id).filtre" :disabled="loading.edicion" required>
                      <option v-for="uno in fields" :key="uno.fieldName" :value="uno.fieldName">{{ uno.name }}</option>
                    </select>
                  </div>
                </div>
              </form>
            </template>
            <template v-slot:footer>
              <button type="submit" class="btn btn-primary" :form="`form-edicion${props.row.id}`" :disabled="loading.edicion"><i-submit icono="fa-pen-to-square" :loading="loading.edicion" />Confirmar</button>
            </template>
          </modal>
          <modal :ref="`modalEliminacion${props.row.id}`" titulo="Eliminar conjunt de dades" icono="fa-solid fa-trash-can" btnClass="btn-secondary" :hayLanzador="false" :modalId="`eliminar-${props.row.id}`" :loading="loading.eliminacion" @abrir="abrirModal(`autofocusEliminacion${props.row.id}`)" @cerrar="cerrarEliminacion">
            <template v-slot:body>
              <div class="alert alert-warning" role="alert"><i class="fa-solid fa-triangle-exclamation mr-1"></i>Aquesta acció no es pot desfer.</div>
              Vols eliminar <b>{{ props.row.titol }}</b>?
            </template>
            <template v-slot:footer>
              <button :ref="`autofocusEliminacion${props.row.id}`" type="submit" class="btn btn-danger" :disabled="loading.eliminacion" @click="eliminar(props.row.id)"><i-submit icono="fa-trash-can" :loading="loading.eliminacion" />Confirmar</button>
            </template>
          </modal>
        </div>
      </template>
      <template slot="tags_str" slot-scope="props">
        <ul class="list-inline">
          <li v-for="(tag, index) in props.row.tags" :key="index" class="list-inline-item">
            <span class="badge badge-primary">{{ tag["tags.titol"] }}</span>
          </li>
        </ul>
      </template>
    </vue-bootstrap4-table>
    <datalist id="datalist-tag">
      <option v-for="(tag, index) in tags" :key="index">{{ tag.titol }}</option>
    </datalist>
  </div>
</template>

<style lang="scss">
[data-toggle="collapse"][aria-expanded="true"] .fa-chevron-down {
  transform: rotate(180deg);
}

[data-toggle="collapse"] .fa-chevron-down {
  transition: transform 0.3s ease;
}
</style>

<script>
const conjuntDades = {
  url: "",
  dataset_id: "",
  tag: "",
  filtre: "",
  titol: "",
  camps: [],
};
const recopilador = {
  tag: "",
  filtre: "",
  cercaExacta: false,
  conjuntsDades: [],
};
export default {
  name: "ConjuntDades",
  inject: ["formatearDecimales", "exportarTabla", "exportarBolcat", "mostrarBolcat", "actionsExportar", "exportarDatos"],
  data() {
    return {
      loading: {
        creacion: false,
        edicion: false,
        eliminacion: false,
        dataset: false,
        recopilador: false,
      },
      rows: [],
      rowsBuffer: [],
      columns: [
        {
          label: "#",
          name: "id",
          filter: {
            type: "simple",
            placeholder: "Filtra Id",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Títol",
          name: "titol",
          filter: {
            type: "simple",
            placeholder: "Filtra títol",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Id. extern",
          name: "dataset_id",
          filter: {
            type: "simple",
            placeholder: "Filtra Id. extern",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Tags",
          name: "tags_str",
          filter: {
            type: "simple",
            placeholder: "Filtra tags",
          },
          sort: true,
          row_text_alignment: "text-left",
        },
        {
          label: "Accions",
          name: "acciones",
          row_text_alignment: "text-center",
        },
      ],
      classes: {
        cell: {
          "align-middle": true,
        },
      },
      config: {
        card_title: "Conjunts de dades",
        global_search: {
          placeholder: "Cerca",
        },
        per_page: 25,
        per_page_options: [25, 50, 100],
        num_of_visibile_pagination_buttons: 5,
      },
      nuevos: {
        conjuntDades: { ...conjuntDades },
      },
      recopilador: { ...recopilador },
      tags: [],
      fields: [],
      allExpanded: false,
      activeTagId: null,
    };
  },
  computed: {
    selectedDatasets() {
      if (!this.recopilador.tag) return [];

      return this.completeRows
        .filter(row => row.tags.some(tag => tag.id_tag == this.recopilador.tag))
        .map(row => ({ ...row, tag: row.tags.find(tag => tag.id_tag == this.recopilador.tag) }));
    },
    validDatasetId() {
      if (!this.nuevos.conjuntDades.url.length) return null;

      return !!this.nuevos.conjuntDades.dataset_id.length;
    },
    completeRows() {
      return this.rows.map(row => ({
        ...row,
        tags_str: row.tags.map(tag => tag["tags.titol"]).join(),
      }));
    },
    allDatasetsSelected: {
      get() {
        return this.selectedDatasets.length > 0 && this.recopilador.conjuntsDades.length === this.selectedDatasets.length;
      },
      set(value) {
        this.recopilador.conjuntsDades = value ? this.selectedDatasets.map(d => d.id) : [];
      },
    },
  },
  methods: {
    getData: function () {
      this.$http.get("api/conjunts_dades").then((response) => this.rows = response.data);

      this.getTags();
    },
    getTags() {
      this.$http.get("api/tags").then((response) => this.tags = response.data);
    },
    getRowId: function (id, rows) {
      return rows.find((element) => {
        return element.id == id;
      });
    },
    getEditingTag(id) {
      const row = this.getRowId(id, this.rowsBuffer);
      if (!row || !this.activeTagId) return null;
      return row.tags.find(t => t.id_tag == this.activeTagId);
    },
    getExportData() {
      const filas = this.$refs.tabla.temp_filtered_results;

      if (!filas.length) return null;

      var filasCompletas = filas
        .map(({ vbt_id, ...keepAttrs }) => keepAttrs)
        .map((fila, i) => ({
          ...fila,
          tags: fila.tags_str,
        }))
        .map(({ tags_str, ...keepAttrs }) => keepAttrs);

      filasCompletas.unshift(Object.keys(filasCompletas[0]));

      return filasCompletas;
    },
    exportarTablaPrevio() {
      const data = this.getExportData();

      if (!data) return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap conjunt de dades per exportar." });

      this.exportarDatos(this.$route.name, data);
    },
    exportarBolcatPrevio() {
      const data = this.getExportData();

      if (!data) return this.$toast.open({ type: "error", position: "top", message: "No hi ha cap conjunt de dades per exportar." });

      this.mostrarBolcat(this.$route.name, data);
    },
    crear: function () {
      this.loading.creacion = true;

      this.$http
        .post("api/conjunts_dades", this.nuevos.conjuntDades)
        .then((response) => {
          this.loading.creacion = false;

          this.$nextTick(() => {
            if (response.status == 201) {
              this.getData();

              this.$refs.modalCreacion.cerrar();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Conjunt de dades afegit correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.creacion = false;
        });
    },
    editar: function (id) {
      this.loading.edicion = true;

      this.$http
        .put(`api/conjunts_dades/${id}`, this.getRowId(id, this.rowsBuffer))
        .then((response) => {
          this.loading.edicion = false;

          this.$nextTick(function () {
            if (response.status == 200) {
              this.$refs[`modalEdicion${id}`].cerrar();

              this.getData();

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Conjunt de dades editat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.edicion = false;
        });
    },
    recopilar() {
      this.loading.recopilador = true;

      const data = { ...this.recopilador };

      if (!data.cercaExacta && data.filtre) {
        data.filtre = `%${data.filtre}%`;
      }

      this.$http
        .post("api/conjunts_dades", data, {
          responseType: 'blob',
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/csv' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = 'recopilacio.zip';
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);

          this.$toast.clear();
          this.$toast.open({ position: "top", message: `Iniciada la descàrrega.` });
        })
        .catch((error) => {
          this.$toast.clear();
          this.$toast.open({ position: "top", message: error.message, type: "error" });
        })
        .finally(() => {
          this.loading.recopilador = false;
        });
    },
    eliminar: function (id) {
      this.loading.eliminacion = true;

      this.$http
        .delete(`api/conjunts_dades/${id}`)
        .then((response) => {
          this.loading.eliminacion = false;

          this.$nextTick(function () {
            this.$refs[`modalEliminacion${id}`].cerrar();

            if (response.status == 200) {
              this.getTags();

              const found = this.rows.find((element) => element.id == id);
              found.eliminado = true;

              this.$toast.clear();
              this.$toast.open({ position: "top", message: `Conjunt de dades eliminat correctament.` });
            }
          });
        })
        .catch((error) => {
          this.loading.eliminacion = false;
        });
    },
    abrirModal: function (autofocus) {
      $(this.$refs[autofocus]).trigger("focus");
    },
    abrirEdicion: function (id) {
      const row = this.getRowId(id, this.rowsBuffer);
      if (row.tags.length > 0) {
        this.activeTagId = row.tags[0].id_tag;
      }
      this.fetchFields(row.dataset_id);
      this.abrirModal(`autofocusEdicion${id}`);
    },
    fetchFields(dataset_id) {
      this.fields = [];
      if (!dataset_id) return;

      this.loading.dataset = true;
      this.$http
        .get(`api/conjunts_dades?dataset_id=${dataset_id}`)
        .then((response) => {
          if (!response.data.columns) throw new Error(response.data);

          this.fields = response.data.columns.map(column => ({
            'name': column.name,
            'description': column.description,
            'fieldName': column.fieldName,
            'examples': column.cachedContents?.smallest && column.cachedContents?.largest ? `${column.cachedContents.smallest} / ${column.cachedContents.largest}` : undefined,
          }));
          this.loading.dataset = false;
        }).catch(() => {
          this.loading.dataset = false;
        });
    },
    cerrarCreacion: function () {
      this.nuevos.conjuntDades = { ...conjuntDades };
      this.fields = [];
    },
    cerrarRecopilador() {
      this.recopilador = { ...recopilador };
      this.allExpanded = false;
    },
    cerrarEdicion: function () {
      this.rowsBuffer = structuredClone(this.rows);
      this.fields = [];
      this.activeTagId = null;
    },
    cerrarEliminacion: function () {
      this.rows = this.rows.filter(function (item) {
        return item.eliminado != true;
      });
    },
    toggleAll() {
      $("#form-recopilador .collapse").collapse(this.allExpanded ? "show" : "hide");
    },
  },
  created() {
    this.getData();
  },
  watch: {
    fields: function (value) {
      if (!value.length) this.nuevos.conjuntDades.camps = [];
    },
    rows: function (value) {
      this.rowsBuffer = structuredClone(value);
    },
    "nuevos.conjuntDades.url"(value) {
      const matches = value.match(/([a-z0-9]{4}-[a-z0-9]{4})/g);

      this.nuevos.conjuntDades.dataset_id = matches ? matches[matches.length - 1] : "";
    },
    "nuevos.conjuntDades.dataset_id"(value) {
      this.fetchFields(value);
      this.nuevos.conjuntDades.tag = "";
      this.nuevos.conjuntDades.filtre = "";
      this.nuevos.conjuntDades.titol = "";

      if (!value.length) return;

      this.$http
        .get(`api/conjunts_dades?dataset_id=${value}`)
        .then((response) => {
          this.nuevos.conjuntDades.titol = response.data.name;
        });
    },
    "recopilador.tag"(value) {
      this.recopilador.conjuntsDades = value ? this.selectedDatasets.map((d) => d.id) : [];
      this.allExpanded = false;
    },
    "recopilador.conjuntsDades"(value) {
      this.$nextTick(() => {
        const checkbox = this.$refs.checkAllDatasets;
        if (checkbox) {
          const count = value.length;
          const total = this.selectedDatasets.length;
          checkbox.indeterminate = count > 0 && count < total;
        }
      });
    },
  },
};
</script>
